import {
  IonButtons,
  IonCard,
  IonCheckbox,
  IonCol,
  IonContent,
  IonGrid,
  IonHeader,
  IonIcon,
  IonInfiniteScroll,
  IonInfiniteScrollContent,
  IonLabel,
  IonMenuToggle,
  IonPage,
  IonRow,
  IonSegment,
  IonSegmentButton,
  IonSpinner,
  IonTitle,
  IonToolbar,
} from "@ionic/react";
import {
  albums,
  card,
  checkmarkDoneCircle,
  mailUnreadOutline,
  menu,
  notifications,
} from "ionicons/icons";
import React, { useEffect, useState } from "react";
import Moment from "react-moment";
import { useCommon } from "../../../common/useCommon";
import { ICart } from "../../../models";
import { TOrdersTab } from "../admin.reducer";
import { ORDERS_PAGE_SIZE, useAdmin } from "../useAdmin";
import OrderDetails from "./OrderDetails";
import { Flex } from "../../../components/Flex/Flex";
import { ID_FRAME_ASSEMBLED } from "../../../common/constants";
import { PaymentBadge } from "./PaymentBadge";
import { reconcilePaymentsApi } from "../../Payment/paymentApi";

const TAKE = ORDERS_PAGE_SIZE;

const CartOrders = () => {
  useCommon();
  const {
    cartTab,
    isLoadingTab,
    cartOrders,
    hasMore,
    total,
    changeTab,
    getCartOrdersPaged,
    setSelectedCart,
    toggleCartHandled,
  } = useAdmin();

  const [isLoadingHandleID, setIsLoadingHandleID] = useState<
    number | undefined
  >();

  const isHandledToggle = async (e: any, cart: ICart) => {
    e.stopPropagation();
    setIsLoadingHandleID(cart.id);
    await toggleCartHandled(cart);
    setIsLoadingHandleID(undefined);
  };

  useEffect(() => {
    getCartOrdersPaged(cartTab, 0, TAKE);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cartTab]);

  // Card payments: resolve payments without a result and pick up captures/voids/refunds
  // done in Merchant Center. Reload the list if anything changed.
  useEffect(() => {
    reconcilePaymentsApi().then((changed) => {
      if (changed > 0) {
        getCartOrdersPaged(cartTab, 0, TAKE);
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const showOrderItems = (cart?: ICart) => {
    if (cart) {
      setSelectedCart(cart);
    }
  };

  const searchNext = async ($event: CustomEvent<void>) => {
    await getCartOrdersPaged(cartTab, cartOrders.length, TAKE);
    ($event.target as HTMLIonInfiniteScrollElement).complete();
  };

  return (
    <IonPage id="cartOrders">
      <IonHeader>
        <IonToolbar color="warning">
          <IonButtons slot="start">
            <IonMenuToggle>
              <IonIcon icon={menu} style={{ fontSize: 28 }} />
            </IonMenuToggle>
          </IonButtons>
          <IonTitle>Pregled porudžbina</IonTitle>
        </IonToolbar>
        <IonToolbar>
          <IonSegment
            value={cartTab}
            onIonChange={(e) => changeTab(e.detail.value as TOrdersTab)}
          >
            <IonSegmentButton value="new-orders">
              <IonIcon
                icon={notifications}
                color={cartTab === "new-orders" ? "primary" : "medium"}
              />
              <IonLabel>
                {cartTab === "new-orders" && !isLoadingTab
                  ? `Nove (${total})`
                  : "Nove"}
              </IonLabel>
            </IonSegmentButton>
            <IonSegmentButton value="done-manual">
              <IonIcon
                icon={checkmarkDoneCircle}
                color={cartTab === "done-manual" ? "primary" : "medium"}
              />
              <IonLabel>Preuzete</IonLabel>
            </IonSegmentButton>
            <IonSegmentButton value="slanje-paketa">
              <IonIcon
                icon={mailUnreadOutline}
                color={cartTab === "slanje-paketa" ? "primary" : "medium"}
              />
              <IonLabel>
                Slanje
                <br />
                paketa
              </IonLabel>
            </IonSegmentButton>
            <IonSegmentButton value="card">
              <IonIcon
                icon={card}
                color={cartTab === "card" ? "primary" : "medium"}
              />
              <IonLabel>Kartice</IonLabel>
            </IonSegmentButton>
          </IonSegment>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        {isLoadingTab && (
          <div className="center">
            <IonSpinner
              name="dots"
              color="warning"
              style={{ width: 60, height: 60 }}
            />
          </div>
        )}
        {!isLoadingTab &&
          cartOrders.map((c) => (
            <IonCard key={c.id}>
              {/* <IonCardContent> */}
              <IonGrid onClick={() => showOrderItems(c)} className="cursorP">
                <IonRow>
                  <IonCol>ID</IonCol>
                  <IonCol className="b vertical-center">
                    <Flex
                      css={{ justifyContent: "space-between", width: "100%" }}
                    >
                      {5000 + (c.id || 0)}
                      <IonCheckbox
                        checked={!!c.is_handled}
                        disabled={isLoadingHandleID === c.id}
                        onClick={(e) => isHandledToggle(e, c)}
                      />
                    </Flex>
                  </IonCol>
                </IonRow>
                <IonRow>
                  <IonCol>Vreme porudžbine</IonCol>
                  <IonCol className="b">
                    <Moment format="DD.MM.YYYY. HH:mm">{c.date}</Moment>
                  </IonCol>
                </IonRow>
                <IonRow>
                  <IonCol>Ime i prezime</IonCol>
                  <IonCol className="b">{c.name}</IonCol>
                </IonRow>
                {cartTab !== "new-orders" && (
                  <IonRow>
                    <IonCol>Adresa</IonCol>
                    <IonCol className="b">{c.address}</IonCol>
                  </IonRow>
                )}
                <IonRow>
                  <IonCol>Mesto</IonCol>
                  <IonCol className="b">{c.place}</IonCol>
                </IonRow>
                <IonRow className="vertical-center">
                  <IonCol>Telefon</IonCol>
                  <IonCol className="b">{c.phone}</IonCol>
                </IonRow>
                <IonRow className="vertical-center">
                  <IonCol>Broj slika</IonCol>
                  <IonCol className="b">
                    <Flex
                      css={{ justifyContent: "space-between", width: "100%" }}
                    >
                      {c.cartItemsCount}
                      {c.country === "BIH" && (
                        <img
                          src="assets/flags/BIH.svg"
                          alt="BIH"
                          style={{ width: 24, height: 16 }}
                        />
                      )}
                    </Flex>
                  </IonCol>
                </IonRow>
                {c.payment_method === "CARD" && (
                  <IonRow>
                    <IonCol size="12">
                      <PaymentBadge cart={c} />
                    </IonCol>
                  </IonRow>
                )}
                <IonRow>
                  <IonCol>
                    {c.cartItems?.find(
                      (c) => c.picture_id === ID_FRAME_ASSEMBLED
                    ) !== undefined && (
                      <IonIcon icon={albums} color="warning" />
                    )}
                  </IonCol>
                  <IonCol
                    className="b"
                    style={{ color: "var(--ion-color-success)" }}
                  >
                    {c.package_sent
                      ? "PORUDŽBINA PREUZETA"
                      : c.package_sent_SP
                      ? "SLANJE PAKETA"
                      : ""}
                  </IonCol>
                </IonRow>
              </IonGrid>
              {/* </IonCardContent> */}
            </IonCard>
          ))}
        <IonInfiniteScroll
          threshold="100px"
          disabled={!hasMore}
          onIonInfinite={(e: CustomEvent<void>) => searchNext(e)}
        >
          <IonInfiniteScrollContent loadingText="Učitavanje..."></IonInfiniteScrollContent>
        </IonInfiniteScroll>
        <OrderDetails />
      </IonContent>
    </IonPage>
  );
};

export default CartOrders;
